import { FC } from "react";
import { Category } from "@/types/category";
import styles from "./index.module.scss";
import { useTextFromTranslations } from "@/helpers/translation";
import { getImageSrc } from "@/helpers/images";

interface CategoryCardProps {
  category: Category;
  onClick: () => void;
}

const CategoryCard: FC<CategoryCardProps> = ({ category, onClick }) => {
  const name = useTextFromTranslations(category.translations)?.name;
  return (
    <div className={styles.container} onClick={onClick}>
      <p className="h6" data-cy="card-category-name">
        {name}
      </p>
      <div className={styles.imageWrapper}>
        <img src={getImageSrc(category)} alt={name} className={styles.image} />
      </div>
    </div>
  );
};

export { CategoryCard };
